'use strict';
const angular = require('angular');

export class castVoteAgreeComponent {
  /*@ngInject*/
  constructor(Auth) {
    this.Auth = Auth;
    this.agreeMessage = "I agree to submit this ballot"
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.hasAttachment) {
      this.agreeMessage = "I agree to submit this ballot and confirm that I have read the attached document";
    }
  };

  ok() {

    if (this.config.secret) {
      this.Auth.validatePassword(this.password)
        .then(() => {
          this.close({$value: this.password});
        })
        .catch(() => {
          this.error = 'Incorrect password';
        });
    } else {
      this.close({$value: 'ok'});
    }

  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.castVoteAgree', [])
  .component('castVoteAgree', {
    template: require('./cast-vote-agree.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: castVoteAgreeComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/cast-vote-agree/cast-vote-agree.component.js